import React from 'react'
import { Paper, Button } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import Text from '../Text'

// Onde o cliente resolve pagamento/verificação da conta WhatsApp Business.
const WHATSAPP_MANAGER_URL = 'https://business.facebook.com/wa/manage/'

// Vermelho = envio bloqueado; laranja = limitado (atenção, mas ainda envia).
const CORES = {
  blocked: '#ef4444',
  warning: '#f97316',
}

/**
 * Banner de saúde da conta Meta.
 *
 * Consome o `accountHealth` que o backend devolve — MESMO formato no snapshot da
 * conexão e no relatório de mensagens —, então o mesmo componente serve as duas
 * telas. Nasceu de um incidente real: a Meta recusava a entrega por falta de
 * método de pagamento (erro 131042) e as mensagens sumiam em silêncio, paradas
 * em "recebida no servidor", sem o cliente ter como saber o motivo.
 *
 * Silencioso por contrato: sem problema, não renderiza NADA — um banner vermelho
 * indevido assusta o cliente à toa.
 */
function MetaAccountHealthBanner({ accountHealth, className = '' }) {
  if (!accountHealth || !accountHealth.hasIssue) return null

  const severidade = accountHealth.severity === 'warning' ? 'warning' : 'blocked'
  const cor = CORES[severidade]
  const Icone = severidade === 'warning' ? WarningAmberIcon : ErrorOutlineIcon
  const motivos = Array.isArray(accountHealth.reasons) ? accountHealth.reasons : []

  return (
    <div className={className}>
      <Paper elevation={0} sx={{ backgroundColor: `${cor}14`, borderLeft: `4px solid ${cor}` }}>
        <div className="p-4 flex items-start gap-3">
          <Icone style={{ color: cor, fontSize: 22, marginTop: 2 }} />
          <div className="flex-1 min-w-0">
            <Text className="text-sm font-black" style={{ color: cor }}>
              {accountHealth.title}
            </Text>
            <Text className="text-xs font-light opacity-90 mt-1 leading-relaxed">
              {accountHealth.message}
            </Text>

            {/* Motivos crus que a Meta devolveu — ajudam o suporte a agir rápido.
                Teto de 3 pra não virar parede de texto. */}
            {motivos.length > 0 && (
              <ul className="mt-2 text-xs font-light list-disc list-inside opacity-70">
                {motivos.slice(0, 3).map((motivo, i) => (
                  <li key={i}>
                    {motivo.description}
                    {motivo.solution ? ` — ${motivo.solution}` : ''}
                  </li>
                ))}
              </ul>
            )}

            {/* Só o problema de pagamento tem um lugar exato pra resolver —
                nos demais (limite/verificação) o caminho varia, então não
                mandamos o cliente pra uma tela que pode não resolver. */}
            {accountHealth.paymentIssue && (
              <Button
                size="small"
                variant="contained"
                startIcon={<OpenInNewIcon style={{ fontSize: 15 }} />}
                href={WHATSAPP_MANAGER_URL}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  mt: 1.5,
                  backgroundColor: cor,
                  '&:hover': { backgroundColor: cor, filter: 'brightness(0.92)' },
                }}
              >
                Configurar pagamento na Meta
              </Button>
            )}
          </div>
        </div>
      </Paper>
    </div>
  )
}

export default MetaAccountHealthBanner
